import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { setToken } from '@/utils/authToken.ts';
import SuspenseFallback from '@/components/SuspenseFallback.tsx';
import useClearCache from '@/hooks/useClearCache.ts';

export const Route = createFileRoute('/impersonate/$token')({
  component: Impersonate,
});

function Impersonate() {
  const { token } = Route.useParams();
  const [clearCache] = useClearCache();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (token.length > 0) {
        setToken(token);
        await clearCache();
      }
      await navigate({ to: '/' });
    })();
  }, [clearCache, navigate, token]);

  return <SuspenseFallback />;
}
